import { useEffect } from "react";
import { NAJVA_CSS_URL, NAJVA_SCRIPT_URL } from "./constants";

export const useNajvaPushNotification = () => {
  useEffect(() => {
    const now = new Date();
    const version = `${now.getFullYear()}0${now.getMonth()}0${now.getDate()}0${now.getHours()}`;

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = `${NAJVA_CSS_URL}?v=${version}`;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `${NAJVA_SCRIPT_URL}?v=${version}`;

    document.head.appendChild(link);
    document.head.appendChild(script);

    return () => {
      link.remove();
      script.remove();
    };
  }, []);
};
